import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import {ApolloClient} from 'apollo-client'
import {ApolloProvider} from 'react-apollo'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {createHttpLink} from 'apollo-link-http'

import App from '../universal/app/Root'

// Autoload required polyfills for IE
Object.assign({}, {})
new Set()
new Map()

const apolloClient = new ApolloClient({
  link: createHttpLink({
    uri: '/app/graphql',
    credentials: 'include',
  }),
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
})

const render = () => ReactDOM.hydrate(
  <ApolloProvider client={apolloClient}>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root')
)

render()
